export default angular.module('eventix.common.services.errorReporter',[])
/**
 * @ngdoc service
 * @name eventix.common.services.angularErrorReporter
 * @description Decorates the $log class to report errors to Rollbar
 */
    .config(function($provide) {
        if(NODE_ENV === 'testing')
            return;
        $provide.decorator('$log', /*@ngInject*/function($delegate) {
            var error = $delegate.error;
            $delegate.error = function() {
                report.apply(null, arguments);
                error.apply($delegate, arguments);
            };

            function report(error) {
                try {
                    console.error(error.message || 'Angular error occured', error);
                } catch (err) {
                /* eslint-disable */
                console.error(error);
                /* eslint-enable */
                }
            }

            return $delegate;
        });
    })
/**
 * @ngdoc service
 * @name eventix.common.services.Rollbar
 * @description A Rollbar proxy service
 */
    .factory('Rollbar', function($log, $window) {
        function forward(...args) {
            var fn = args.shift();
            unavailable();
            if(fn === 'error' || fn === 'log')
                $log[fn].apply($log, args);
        }

        var unavailable = _.once(function() {
            $log.error('Rollbar is not available to log this error');
        });

        return {
            error: forward.bind(null, 'error'),
            configure: forward.bind(null, 'configure'),
            log: forward.bind(null, 'log')
        };
    }).name;
